
export const bitrixUrl = 'https://niatech.bitrix24.com.br/rest/1/9cwjchlqktog52yq';

// export const apiBaseUrl = 'https://app-nia-tech.eastus.cloudapp.azure.com:5050';
export const apiBaseUrl = 'https://app.nia.tech:5050';

export const localUrl = 'http://localhost:8080';